import { gql } from 'graphql-request';
import { merchantServiceGraphql } from '../config/Config';

export const getTariffByTerminalID = async (terminalID) => {
  const variables = {
    filter: {
      TerminalID: terminalID,
    },
  };

  const TARIFF = gql`
    query Tariff($filter: TariffWhereInput) {
      Tariff(filter: $filter) {
        domainname
        tarifftype
        tariffrole
        personalisationtype
        tariffname
        tariffstartdate
        tariffvalue
        domainlevel
        id
        contract
        globaltariff
        personaltariff
        tariffdomain
        activetariffdata
        tariffandcontract
        dueperiod
        graceperiod
        currency
        mincount
        maxcount
        minamount
        maxamount
        baseamount
        singleamount
        fxratetype
        ratevalue
        feeratevalue
        applymode
        datefrom
      }
    }
  `;

  const response = await merchantServiceGraphql.request(TARIFF, variables);

  return response.Tariff;
};
